import React, { Component } from "react";
import { Modal, Checkbox, Spin, Tag, Alert, message } from "antd";
import { FileProtectOutlined } from "@ant-design/icons";
import { cmmsPost } from "../cmmsComun";
import "../cmms.css";

// Carga los formatos del F-SE-14 (y sus equipos patron) como plantillas editables, para no
// capturar a mano los 19 certificados.
class ModalEjemplosCertificado extends Component {
    state = { cargando: false, guardando: false, ejemplos: [], elegidos: [], conPatrones: true, patronesRegistrados: 0 };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) this.cargar();
    }

    cargar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "ejemplosCertificadoCMMS");
            if (res.data.success === 2) {
                const nuevos = res.data.ejemplos.filter((e) => !e.yaExiste).map((e) => e.clave);
                this.setState({ ejemplos: res.data.ejemplos, elegidos: nuevos, patronesRegistrados: res.data.patronesRegistrados, conPatrones: true });
            } else message.error(res.data.message || "No se pudieron consultar los formatos");
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ cargando: false });
        }
    };

    importar = async () => {
        this.setState({ guardando: true });
        try {
            const res = await cmmsPost(this.props, "importarEjemplosCertificadoCMMS", { claves: this.state.elegidos, conPatrones: this.state.conPatrones });
            if (res.data.success === 2) {
                message.success(`${res.data.plantillasNuevas} plantilla(s) y ${res.data.patronesNuevos} equipo(s) patrón agregados`);
                this.props.onClose(true);
            } else message.error(res.data.message || "No se pudieron cargar");
        } catch (error) {
            console.log(error);
            message.error("No se pudieron cargar");
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const { ejemplos, elegidos } = this.state;
        const disponibles = ejemplos.filter((e) => !e.yaExiste);
        return (
            <Modal
                className="cmms-modal"
                visible={this.props.visible}
                onCancel={() => this.props.onClose(false)}
                onOk={this.importar}
                okText="Cargar"
                cancelText="Cancelar"
                confirmLoading={this.state.guardando}
                okButtonProps={{ disabled: !elegidos.length && !this.state.conPatrones }}
                width={window.innerWidth > 760 ? 680 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        <FileProtectOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">Formatos F-SE-14</div>
                            <div className="cmms-modal-subtitulo">Sus 19 certificados de verificación, listos para usar. Después se pueden editar como cualquier plantilla.</div>
                        </div>
                    </div>
                }
            >
                <Spin spinning={this.state.cargando}>
                    <div className="cmms-modal-cuerpo" style={{ paddingBottom: 12 }}>
                        <Checkbox
                            checked={disponibles.length > 0 && elegidos.length === disponibles.length}
                            indeterminate={elegidos.length > 0 && elegidos.length < disponibles.length}
                            disabled={!disponibles.length}
                            onChange={(e) => this.setState({ elegidos: e.target.checked ? disponibles.map((x) => x.clave) : [] })}
                            style={{ marginBottom: 8, fontWeight: 600 }}
                        >
                            Todos
                        </Checkbox>
                        <div style={{ maxHeight: 340, overflowY: "auto", border: "1px solid #e3e8ee", borderRadius: 6, padding: "6px 10px", background: "white" }}>
                            {ejemplos.map((e) => (
                                <div key={e.clave} style={{ padding: "3px 0" }}>
                                    <Checkbox
                                        disabled={e.yaExiste}
                                        checked={elegidos.includes(e.clave)}
                                        onChange={(ev) => this.setState((s) => ({ elegidos: ev.target.checked ? [...s.elegidos, e.clave] : s.elegidos.filter((c) => c !== e.clave) }))}
                                    >
                                        <b>{e.clave}</b> · {e.nombre} {e.yaExiste && <Tag style={{ marginLeft: 6 }}>Ya existe</Tag>}
                                    </Checkbox>
                                </div>
                            ))}
                        </div>
                        <Checkbox style={{ marginTop: 10 }} checked={this.state.conPatrones} onChange={(e) => this.setState({ conPatrones: e.target.checked })}>
                            Cargar también los equipos patrón del F-SE-14 (simuladores y analizadores)
                        </Checkbox>
                        {this.state.conPatrones && (
                            <Alert
                                type="warning"
                                showIcon
                                style={{ marginTop: 8 }}
                                message="Sus fechas de calibración vienen del Excel (2019 a 2023): actualícelas en Equipos patrón antes de emitir certificados. Los que ya existan (mismo modelo y serie) no se duplican."
                            />
                        )}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default ModalEjemplosCertificado;
